import { capitalizeFirstLetter } from '@lib/services/stringsService';

export const normalizeRetriedChannels = (channels: { name: string; reason: string }[]) => {
  const channelsCopy = [...channels];
  // remove the current Message from the retries to show
  channelsCopy.pop();

  const onlyChannelsWithName = channelsCopy.filter((item) => Boolean(item.name));
  const normalizedChannels = onlyChannelsWithName.map((item) => ({ ...item, name: capitalizeFirstLetter(item.name) }));
  return normalizedChannels;
};

export const fromListToLocaleString = (list: string[], andMessage: string, isToUseOxfordComma: boolean) => {
  const cloneList = [...list];
  if (cloneList.length === 1) return cloneList.join(', ');

  const lastElement = cloneList.pop() || '';
  cloneList.push(andMessage);
  cloneList.push(lastElement);
  const toString = cloneList.join(', ');
  return toString.replace(
    `${!isToUseOxfordComma ? ', ' : ''}${andMessage},`,
    `${!isToUseOxfordComma ? ' ' : ''}${andMessage}`,
  );
};
